import { getSeedingDeliveryAddresses as getSeedingDeliveryAddressesApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetSeedingDeliveryAddressesServiceResponse } from './get-seeding-delivery-addresses.dto';
import { GetSeedingDeliveryAddressesServiceResponseSchema } from './get-seeding-delivery-addresses.dto';

/** 큐레이터 시딩 배송지 목록 (29CM 한정 — 배송지 변경 화면). */
export const getSeedingDeliveryAddressesService = withServiceErrorCapture(
  lazyPipe(async (): Promise<GetSeedingDeliveryAddressesServiceResponse> => {
    const apiResponse = await getSeedingDeliveryAddressesApi();

    if (apiResponse.meta?.result === 'FAIL') {
      throw new Error(apiResponse.meta?.message ?? '배송지 목록 조회에 실패했습니다.');
    }
    return apiResponse.data;
  }, validateServiceResponse(GetSeedingDeliveryAddressesServiceResponseSchema)),
);
